import axios from "axios";

const { REACT_APP_SERVER_URL: SERVER_URL } = process.env;
const BASE_URL = `${SERVER_URL}/fastest-finger`;

async function getFastestFinger(token) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.get(`${BASE_URL}/`);
    return data;
  } catch (e) {
    throw e;
  }
}

async function startGame(token) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    await axios.get(`${BASE_URL}/start-game`);
  } catch (e) {
    throw e;
  }
}

async function getGameStatus(token) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.get(`${BASE_URL}/game-status`);
    return data;
  } catch (e) {
    throw e;
  }
}


export default {
  getFastestFinger,
  startGame,
  getGameStatus,
};
